import {createContext} from 'react'
import {Response} from '../../../../../_dashboard/helpers'

export type MailOrderStatus =
  | 'pending'
  | 'partially_paid'
  | 'paid'
  | 'expired'
  | 'cancelled'

export interface MailOrderUserRef {
  firstName?: string
  lastName?: string
  email?: string
}

export interface MailOrder {
  _id: string
  circuitName: string
  circuitStartDate: string
  circuitEndDate: string
  bookingReference?: string
  participantsCount: number
  description?: string
  circuitSummary?: string
  currency: string
  totalPrice: number
  clientName: string
  clientEmail: string
  clientPhone: string
  clientLanguage: 'fr' | 'en' | 'de'
  billingAddress?: string
  clientCountry?: string
  status: MailOrderStatus
  installmentsCount: number
  paidAmount: number
  remainingAmount: number
  createdBy?: MailOrderUserRef
  updatedBy?: MailOrderUserRef
  createdAt: string
  updatedAt: string
}

export type MailOrdersQueryResponse = Response<Array<MailOrder>>

export type QueryResponseMailOrderContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}

export function createMailOrderResponseContext<T>(
  initialState: QueryResponseMailOrderContextProps<T>
) {
  return createContext(initialState)
}

export const initialMailOrderQueryResponse = {
  refetchData: () => {},
  isLoading: false,
  query: '',
}
